import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class CustomTabItem extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "label", Model.attribute('label'));
    _defineProperty(this, "url", Model.attribute('url'));
    _defineProperty(this, "icon", Model.attribute('icon'));
    _defineProperty(this, "isNewTab", Model.attribute('isNewTab'));
    _defineProperty(this, "isInternal", Model.attribute('isInternal'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
  }
}
flarum.reg.add('gitzaai-v2mobileui', 'common/models/CustomTabItem', CustomTabItem);